import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function PreferedPrice(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: ({ createOrUpdate }) => ({})
    }));

    const getName = () => {
        return 'Предпочитана цена';
    }

    const getType = () => {
        return 'prefered_price';
    }

    const getTitle = () => {
        return null;
    }

    const hasSettings = () => false;

    const getSettings = ({ state, setConfig, createOrUpdate }) => {
        return null;
    }

    return getName();
}

export default forwardRef(PreferedPrice)